class BxfProgressIndicatorConstants {
    static STRING = {
        BXF_PROGRESS_INDICATOR_BAR_WRAPPER: 'bxf-progress-indicator-bar__wrapper',
        BXF_PROGRESS_INDICATOR_BAR_REGULAR: 'bxf-progress-indicator-bar__regular',
        BXF_PROGRESS_INDICATOR_BAR_REGULAR_PROGRESS: 'bxf-progress-indicator-bar__regular--progress',
        BXF_PROGRESS_INDICATOR_BAR_REGULAR_RIGHT_LABEL: 'bxf-progress-indicator-bar__regular--right-label',
        BXF_PROGRESS_INDICATOR_BAR_LARGE: 'bxf-progress-indicator-bar__large',
        BXF_PROGRESS_INDICATOR_BAR_LARGE_PROGRESS: 'bxf-progress-indicator-bar__large--progress',
        BXF_PROGRESS_INDICATOR_COUNTER: 'bxf-progress-indicator__counter',
        BXF_PROGRESS_INDICATOR_LABEL: 'bxf-progress-indicator__label',
        BXF_PROGRESS_INDICATOR_LABEL_COUNTER_CONTAINER: 'bxf-progress-indicator__label-counter--container',
        BXF_PROGRESS_RING: 'bxf-progress-ring',
        BXF_PROGRESS_RING_CONTAINER: 'bxf-progress-ring__container',
        BXF_PROGRESS_RING_CIRCLE: 'bxf-progress-ring__circle',
        BXF_PROGRESS_RING_CIRCLE_BACKGROUND: 'bxf-progress-ring__background-circle',
        BXF_PROGRESS_RING_LABEL_REGULAR: 'bxf-progress-ring-label__regular',
        BXF_PROGRESS_RING_LABEL_LARGE: 'bxf-progress-ring-label__large',
        BXF_PROGRESS_SPINNER_VALUE: 25,
        BXF_PROGRESS_RING_OVERLAY: 'bxf-progress-ring__overlay',
    };
}

export { BxfProgressIndicatorConstants as B };
